<template>
  <div class="sendMsgCont line">
    <div class="msgBox">
      <div class="msgTypeBox">
        <!-- <div class="boxInner">
          <span class="typeName">テンプレート名</span>
          <v-select
            v-model="templateId"
            :items="templateList"
            item-text="name"
            item-value="value"
            label="選択"
            class="UXselect templateSelectBox"
            color="#5578F0"
            hide-details
            outline
            solo
            @change="getTemplate()"
          ></v-select>
        </div> -->
        <div class="boxInner" v-if="!templateOn && images.length === 0">
          <span class="typeName">イメージ添付</span>
          <div class="msgBtm">
            <div class="btnTem">
              <upload-btn
                class="mmsImageFile"
                accept=".jpg"
                ref="fileInput"
                @file-update="uploadImage"
                @click.native="$refs.fileInput.clear()"
                :noTitleUpdate="true"
                :disabled="templateOn || images.length > 0"
                title="画像アップロード"
                outline
                color="#BEBEBE"
                no-data-text="データがありません。"
              ></upload-btn>
            </div>
          </div>
        </div>
        <div v-else class="boxInner">
          <v-btn v-if="templateOn"  outline class="medium down emphasis" @click="resetLineParam()">テンプレート初期化</v-btn>
          <v-btn v-else outline class="medium down emphasis" @click="resetLineParam('IMAGE')">イメージ初期化</v-btn>
        </div>
      </div>
      <p v-if="!templateOn && images.length === 0" style="text-align: left;font-size: 14px;color: #999999;padding-right: 10px;">適正サイズ930 * 510</p>
      <div class="msgTemplate">
      <div class="temp_notice" v-if="templateOn">
        <p>※テンプレートの編集はできません。</p>
      </div>
      <div class="lineTemplate" v-if="templateOn">
        <marketing-preview>
        </marketing-preview>
      </div>
      <div class="lineTemplate" v-else>
        <div class="preview_body">
          <div class="lineProfile">
            <div class="profImg"><img src="https://public-outai-gate-storage.s3.ap-northeast-3.amazonaws.com/login_id/QscUWBKFPZ.png"></div>
          </div>
          <div class="imageBox" v-if="images.length > 0">
            <div v-for="(item, index) in images" :key="index">
              <v-img
                class="align-center text-center"
                :src="item.src"
                height="190"
                style="border-radius: 15px 15px 0px 0px;"
                cover
                position="center center">
              </v-img>
            </div>
          </div>
          <div v-if="templateType !== 'IMAGE' && title" class="titleTxt">
            <span>{{title}}</span>
          </div>
          <div class="advertTxt smallTxt">
            <v-textarea
              v-if="contentOn"
              v-model="content"
              :placeholder="templateOn ? '' : 'テキストは最大2,000文字まで記入できます。'"
              auto-grow
              :readonly="templateOn"
              maxLength="2000"
              rows="5">
            </v-textarea>
          </div>
          <div class="buttonList" v-if="button.length > 0">
            <ul>
              <li v-for="(item, index) in button" :key="index">
                <v-btn flat icon>
                  {{item.name}}
                </v-btn>
              </li>
            </ul>
          </div>
        </div>
      </div>
      </div>
      <div class="cenBtn" style="padding-top:20px">
        <v-btn round dark large color="#ff8c8c" class="UXbtn widthAuto" :loading="loading" :disabled="noContent || loading" @click="sendLineNow()">送信</v-btn>
      </div>
    </div>
  </div>
</template>
<script>
import uploadImages from '@/components/mixin/UploadImages'
import {mapGetters, mapMutations} from 'vuex'
import marketingPreview from '../../marketing/marketingPreview'

export default {
  name: 'customerSendLine',
  mixins: [uploadImages],
  components: {
    marketingPreview
  },
  props: {
    templateList: {
      type: Array
    },
    customerList: {
      type: Array
    },
    mailSendCheck: {
      type: Boolean
    }
  },
  data () {
    return {
      templateId: '',
      sendFailMail: false,
      title: '',
      content: '',
      templateType: '',
      button: [],
      templateOn: false,
      images: [],
      textLength: 0,
      loading: false
    }
  },
  watch: {
    templateId (val) {
      if (!val) {
      } else {
        this.templateOn = true
        this.images = []
        this.button = []
        this.content = ''
      }
    }
  },
  computed: {
    ...mapGetters([
      'currentBrandId',
      'ticketAgentId',
      'currentTicketBrandId'
    ]),
    noContent () {
      return !this.content && this.images.length === 0
    },
    contentOn () {
      if (this.templateType === 'IMAGE') {
        return false
      } else if (this.templateOn) {
        if (this.content === '') {
          return false
        }
        return true
      } else {
        return true
      }
    }
  },
  created () {
    this.resetmarketingLineTemplate()
  },
  methods: {
    ...mapMutations([
      'changeLineTemplateView',
      'resetmarketingLineTemplate'
    ]),
    resetLineParam (value) {
      this.resetmarketingLineTemplate()
      if (value === 'IMAGE') {
        this.images = []
      } else {
        this.images = []
        this.button = []
        this.title = ''
        this.content = ''
        this.templateType = ''
        this.templateId = ''
        this.sendFailMail = false
        this.templateOn = false
      }
    },
    getTemplate () {
      this.resetmarketingLineTemplate()
      this.$http.get('/api/marketing/v2/fetchMarketingContent', {
        params: {
          marketingId: this.templateId
        }
      })
        .then(result => {
          const response = result.data
          if (response.code === 0) {
            // this.changeTemplateView(response.data.marketingFlowViews[0].data)
            this.changeLineTemplateView(response.data.marketingFlowViews[0].data)
          } else {
            throw response.message
          }
        })
        .catch(errorMsg => {
          this.$alertMsg(errorMsg)
        })
    },
    // changeTemplateView (data) {
    //   this.title = data.content.title
    //   this.content = data.content.description
    //   this.templateType = data.templateType
    //   if (data.content.imageUrl) {
    //     this.images.push({
    //       src: data.content.imageUrl
    //     })
    //   }
    //   this.button = data.content.button
    // },
    sendLineNow () {
      this.loading = true
      let paramData = this.lineParamConverter()
      let apiUrl = ''
      if (this.templateOn) {
        apiUrl = '/api/marketing/push/sendLineMarketingNow' // 템플릿 적용
      } else {
        apiUrl = '/api/instantMessage/push/sendLineMessageNow'
      }
      this.$http.post(apiUrl,
        paramData
      ).then(result => {
        const response = result.data
        if (response.code === 0) {
          this.$alertMsg(`${response.data.sendTargetCount}件のうち${response.data.sendTargetCount}件を送りました。`, '', () => { this.$emit('close') })
        } else {
          throw response.message
        }
      }).catch(errorMsg => {
        this.$alertMsg(errorMsg)
      }).finally(() => {
        this.loading = false
      })
    },
    lineParamConverter () {
      let data = {}
      if (this.templateOn) {
        data = {
          brandId: this.currentBrandId,
          customerIds: this.customerList,
          moduleChannelType: 'LINE',
          sendFailMail: this.sendFailMail,
          marketingId: this.templateId,
          viewTarget: '',
          ticketAgentId: this.ticketAgentId,
          currentTicketBrandId: this.currentTicketBrandId
        }
      } else {
        data = {
          brandId: this.currentBrandId,
          customerIds: this.customerList,
          moduleChannelType: 'LINE',
          sendFailMail: this.sendFailMail,
          sendContent: {
            templateType: 'IMAGE_TEXT_BUTTON',
            order: 0,
            content: {
              title: '',
              description: this.content,
              imageUrl: this.images.length > 0 ? this.images[0].src : '',
              imageLink: '',
              button: []
            }
          },
          viewTarget: '',
          ticketAgentId: this.ticketAgentId,
          currentTicketBrandId: this.currentTicketBrandId
        }
      }
      return data
    }
  }
}
</script>

<style lang="scss">
  .sendMsgCont {
    padding: 0px;
    &.line {
      .msgTemplate {
        background: url(https://public-common-sdk-outaigate.s3.ap-northeast-3.amazonaws.com/image/line_bg.png)no-repeat center;
        &::-webkit-scrollbar-track {
          margin: 2px;
        }
        &::-webkit-scrollbar-thumb {
          background: #eeeeee;
          border-radius: 10px;
          border: 4px solid #7992be;
        }
        &::-webkit-scrollbar {
          width: 14px;
        }
      }
    }
    .hoverInp {
      border: none;
      input {
        border: 1px solid #4A52FF;
        &:focus, &:hover {
          box-shadow: 0 0 0 0.5px #4A52FF inset;
        }
      }
    }
    .templateSelectBox{
      width: 170px;
      padding-left: 10px;
    }
    .msgTypeBox {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .boxInner {
        width: 48%;
        display: flex;
        align-items: center;
        margin-right: 15px;
        .typeName {
          font-size: 14px;
          white-space: nowrap;
          margin-right: 10px;
          color: #414141;
        }
        .mmsImageFile {
          .upload-btn {
            padding: 0 10px;
            color: #919191;
            cursor: pointer;
          }
        }
      }
    }
    .msgTemplate {
      height: 480px;
      overflow-y: auto;
      border-radius: 5px;
      border: 1px solid #e8e8e8;
      margin-top: 1rem;
      .temp_notice {
        background: #48566E;
        color: #fff;
        text-align: center;
        padding: 10px;
        p {
          margin: 0;
        }
      }
      .lineTemplate {
        border: none;
        margin-top: 20px;
        .preview_body {
          position: relative;
          background: #fff;
          max-width: 310px;
          margin: 30px auto;
          box-shadow: 0 0 14px rgba(0, 0, 0, .2);
          border-radius: 18px;
          .lineProfile {
            position: absolute;
            top: -30px;
            left: -67px;
            font-weight: bold;
            color: #3B4659;
            font-size: 14px;
            .profImg {
              margin-right: 12px;
              img {
                max-width: 50px;
                height: 50px;
                object-fit: cover;
                border-radius: 100%;
              }
            }
          }
          .imageBox {
            line-height: 0;
            img {
              width: 100%;
              border-radius: 18px 18px 0 0;
            }
            .v-btn {
              position: absolute;
              top: 5px;
              right: 5px;
              z-index: 3;
              margin: 0;
              i {
                font-size: 38px;
              }
            }
          }
          .titleTxt {
            font-weight: bold;
            font-size: 21px;
            padding: 15px 15px 0;
            color: #414141;
            line-height: 23px;
          }
          .advertTxt {
            padding: 10px 15px;
            .v-text-field {
              padding: 0;
              margin: 0;
            }
            .v-input__control > .v-input__slot:before, .v-input__control > .v-input__slot:after {
              display: none;
            }
            textarea {
              font-size: 16px;
              line-height: 18px;
              color: #676767;
            }
          }
          .buttonList ul {
            list-style: none;
            padding: 15px;
            button {
              color: #39689F!important;
              display: block;
              width: 100%;
              margin: 0;
              padding: 10px;
              height: 50px;
              font-weight: 500;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/menus/customer/components/customerSendLine.vue